export default __webpack_public_path__ + "static/media/kaizer.c718bd6c.png";